module.exports = __webpack_public_path__ + "img/profile_icon.0748b6e3.png";